// extracted by mini-css-extract-plugin
export default {"dots":"TypingDots_dots__oVfbp","dots__item":"TypingDots_dots__item__vr9Bk","typingAnimation":"TypingDots_typingAnimation__Kvsko"};